import useExperimentDebug from '@/platform/composables/useExperimentDebug';

const maxRetries = 10;
const retryTimeInMilliseconds = 500;
const { isExperimentDebugEnabled } = useExperimentDebug();

/*
 * PendoHelper - Helper functions for Pendo
 */

/**
 * @returns {Boolean}
 */
export function isPendoReady() {
  return window.pendo?.isReady && window.pendo?.isReady();
}

/**
 * Logs Pendo Track Event name and metadata to the console.
 *
 * @param {string} eventName Name of the LaunchDarkly key
 * @param {Object} metadata Object to be passed to pendo.track
 */
function logExperimentEvent(eventName, metadata) {
  if (Object.entries(metadata).length > 0) {
    console.info(`=== Pendo: ${eventName}`, metadata);
  } else {
    console.info(`=== Pendo: ${eventName}`);
  }
}

/**
 *
 * @param {string} eventName pendo event key
 * @param {Record<string, string | number | string[]} metadata pendo metadata object
 * @param {number} retryCount initial retry count
 * @param {boolean} skipTimeout skip the first timeout and send instantly
 */
export function trackPendoEvent(
  eventName,
  metadata = {},
  retryCount = 0,
  skipTimeout = false,
) {
  if (isPendoReady()) {
    if (isExperimentDebugEnabled.value) {
      logExperimentEvent(eventName, metadata);
    }
    window.pendo.track(eventName, metadata);
    return;
  }
  if (retryCount >= maxRetries) {
    return;
  }
  setTimeout(
    () => {
      trackPendoEvent(eventName, metadata, retryCount + 1);
    },
    skipTimeout ? 0 : retryTimeInMilliseconds,
  );
}
